<template>
  <div class="wrapper">
    <div class="filter white_box">
      <div class="filter-row">
        <!-- 搜索框 -->
        <el-input
          class="custom-es"
          size="medium"
          placeholder="请输入员工姓名/证件号码/手机号码"
          v-model="input"
          clearable
        ></el-input>
        <!-- 入职日期 -->
        <div class="date-group">
          <span class="date-label">入职日期：</span>
          <!-- 日期选择器 -->
          <el-date-picker
            v-model="RegDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            value-format="yyyy-MM-dd"
            end-placeholder="结束日期"
            size="medium"
          >
          </el-date-picker>
        </div>

        <!-- 用工状态标签 -->
        <div class="status-group">
          <p class="font_14_black">用工状态：</p>
          <filter-tag
            :class="{ active: status[0] }"
            @click.native="change('status', 0)"
            :name="'在职 ' + onTheJob"
          />
          <filter-tag
            :class="{ active: status[1] }"
            @click.native="change('status', 1)"
            :name="'离职 ' + quitTheJob"
          />
        </div>

        <!-- 按钮组 -->
        <div class="button-group">
          <button-a color="#f26828" class="query" @click.native="query()"
            >查询</button-a
          >
          <button-a color="#08a752" @click.native="reset()">重置</button-a>
          <button-a
            class="export"
            color="#ffffff"
            bgcolor="#85cf96"
            @click.native="dialog()"
            :loading="exportLoading"
            >{{ exportLoading ? '正在导出中...' : '导出' }}</button-a
          >
        </div>
      </div>
    </div>

    <div class="result white_box">
      <!-- 标签筛选 -->

      <!-- 表格
        ref="multipleTable" 引用名
        :data="tableData" 绑定数据
        tooltip-effect 鼠标hover提示效果
        :header-row-style 表头样式
        :header-cell-style 表头单元格样式
        :row-style="rowStyle" 行样式
      -->
      <div v-loading="loading" element-loading-text="加载中..." class="table-wrapper">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        :header-row-style="{
          height: translateWidth(68) + 'px',
          fongSize: '14px',
          color: '#000',
          backgroundColor: '#fafbff'
        }"
        :header-cell-style="{ backgroundColor: 'transparent' }"
        :row-style="{
          
          height: translateWidth(60) + 'px',
          backgroundColor: '#fff'
        }"
        style="
          width: 100%;
          font-size: 14px;
          color: #707070;
          border: 1px solid #e5e5e5;
          border-radius: 6px;
        "
        @row-click="handleRowClick"
        @row-dblclick="handleRowDblclick"
        @row-mousedown="handleRowMousedown"
        @row-mousemove="handleRowMousemove"
        @row-mouseup="handleRowMouseup"
      >
        <!-- 表格行
          type="index" 指定为索引列
          label 列名
          prop 指定内容对应的属性键名
          show-overflow-tooltip 当内容过长被隐藏时显示tooltip
          需要根据prop进行计算渲染时，不指定prop，使用template，其slot-scope="scope"获取此行数据
        -->
        <!-- 占位列 -->
        <el-table-column
          :width="tableWidth[0] | translateWidth"
        ></el-table-column>
        <!-- 多选框 -->
        <!-- <el-table-column type="selection" width="66"></el-table-column> -->
        <el-table-column
          type="index"
          label="序号"
          :width="tableWidth[1] | translateWidth"
        ></el-table-column>
        <el-table-column
          prop="customerName"
          label="所属企业"
          show-overflow-tooltip
          :width="tableWidth[2] | translateWidth"
        ></el-table-column>
        <el-table-column
          prop="realName"
          label="员工姓名"
          show-overflow-tooltip
          :width="tableWidth[3] | translateWidth"
        ></el-table-column>
        <el-table-column
          prop="idCard"
          label="证件号码"
          show-overflow-tooltip
          :width="tableWidth[4] | translateWidth"
        ></el-table-column>
        <el-table-column
          prop="mobilePhone"
          label="手机号码"
          show-overflow-tooltip
          :width="tableWidth[7] | translateWidth"
        ></el-table-column>
        <el-table-column
          label="用工状态"
          show-overflow-tooltip
          :width="tableWidth[5] | translateWidth"
        >
          <template slot-scope="scope">{{
            scope.row.status === 0
              ? '未入职'
              : scope.row.status === 1
              ? '在职'
              : '离职'
          }}</template>
        </el-table-column>
        <el-table-column
          label="入职日期"
          show-overflow-tooltip
          :width="tableWidth[6] | translateWidth"
        >
          <template slot-scope="scope">{{
            date(scope.row.entryDate)
          }}</template>
        </el-table-column>
        

        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="font_14_orange pointer view" @click="view(scope.row)"
              >查看</span
            >
          </template>
        </el-table-column>
      </el-table>
      </div>
      <!-- 分页 -->
      <!-- 
        hide-on-single-page Boolean，只有一页时隐藏
        :current-page="page" 绑定当前页码
        @size-change="handleSizeChange" 每页条数改变回调
        @current-change="handleCurrentChange" 当前页码改变回调
        layout="total, prev, pager, next, sizes, jumper, ->, slot" 显示选项
          total 总条数
          prev 前一页
          pager 页码
          next 后一页
          sizes 每页条数
          jumper 输入并跳转某页
          -> 
          slot 自定义内容
      -->
      <el-pagination
        ref="pagination"
        :current-page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, sizes, jumper, ->, slot"
        :total="total"
        :pager-count="5"
      ></el-pagination>
    </div>
    <!-- 导出对话框 -->
    <el-dialog title :visible.sync="mask" width="50%" center>
      <h3 class="export-title font_16_black">员工信息导出</h3>
      <div class="transfer">
        <el-transfer
          style="text-align: left; display: inline-block"
          v-model="export_value"
          :data="export_data"
          filterable
          :titles="['请选择导出字段', '已选择字段']"
          :button-texts="['到左侧', '到右侧']"
        >
        </el-transfer>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="export_btn">
          <button-a
            padding="10px 128px"
            color="#fff"
            bgcolor="#f26828"
            @click.native="exportExcel()"
          >导出</button-a>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Get, Download } from '@/js/http.js'
import { Filter, dateConvert, labelOfValue, translateWidth } from '@/js/tool.js'

export default {
  name: 'EmployeeInfo',
  components: {},
  props: {},
  data () {
      return {
        tableWidth: [35, 94, 294, 182, 280, 168, 180, 180],
        RegDateRange: [],
        input: '', // 员工搜索输入
        status: {
          0: true, // 在职
          1: true // 离职
        },
        clickTimer: null, // 单击定时器
        isDragging: false, // 是否正在拖动
        isDoubleClick: false, // 是否双击
      onTheJob: 0, // 在职数
      quitTheJob: 0, // 离职数
      options: [
        // 组织搜索框选项，格式如下
        // {
        //   value: "HTML",
        //   label: "HTML"
        // },
      ],
      selectedValue: '', // 选择的组织id
      selectedValue2: [], // 选择的组织id 导出框
      page: 1, // 当前页码
      size: 10, // 每页条数
      total: 0, // 总条数
      tableData: [], // 表格数据
      mask: false, // 遮罩
      export_data: [
        { key: '员工姓名', label: '员工姓名', disabled: true },
        { key: '所属企业', label: '所属企业', disabled: true },
        { key: '证件类型', label: '证件类型' },
        { key: '证件号码', label: '证件号码', disabled: true },
        { key: '手机号码', label: '手机号码' },
        { key: '电子邮箱', label: '电子邮箱' },
        { key: '性别', label: '性别' },
        { key: '国籍', label: '国籍' },
        { key: '政治面貌', label: '政治面貌' },
        { key: '生育状况', label: '生育状况' },
        { key: '户籍类型', label: '户籍类型' },
        { key: '现居住地', label: '现居住地' },
        { key: '出生日期', label: '出生日期' },
        { key: '民族', label: '民族' },
        { key: '婚姻状况', label: '婚姻状况' },
        { key: '籍贯', label: '籍贯' },
        { key: '户籍所在地', label: '户籍所在地' },
        { key: '在职岗位', label: '在职岗位' },
        { key: '用工形式', label: '用工形式' },
        { key: '用工性质', label: '用工性质' },
        { key: '入职日期', label: '入职日期' },
        { key: '用工状态', label: '用工状态', disabled: true }
      ],
      export_value: [
        '员工姓名',
        '所属企业',
        '证件号码',
        '用工状态'
      ],
      exportLoading: false, // 导出加载状态
      loading: false, // 数据加载状态
      switchGroup1: {
        在职: true,
        离职: true
      },
      disabled: '' // 禁止修改的开关
    }
  },
  watch: {},
  computed: {
    // 选择的组织名称
    selectLabel () {
      return labelOfValue(this.selectedValue2, this.options)
    },
    // 查询表格跳过的条数
    SkipCount () {
      return (this.page - 1) * this.size
    }
  },
  methods: {
    // 获取组织数据
    getOptions () {
      Get('api/v1/customers/selectors').then(({ data }) => {
        this.options = data
      })
    },
    // getStatus () {
    //   Get('api/EmployeeInfo/GetNowEmployeeStatus', {
    //     // customerId: this.selectedValue || '', // 客户ID
    //     employeName: this.input
    //   }).then(({ data }) => {
    //     this.onTheJob = data.status1
    //     this.quitTheJob = data.status2
    //   })
    // },
    // 获取表格数据
    getData () {
      this.loading = true
      let STATUS = ''
      if (this.status[0] && this.status[1]) {
        STATUS = -1
      } else if (this.status[0]) {
        STATUS = 1
      } else {
        STATUS = 2
      }
      let regDateRange = this.RegDateRange ?? [null, null]
      Get('api/v1/employees', {
        // customerId: this.selectedValue || '', // 客户ID
        Keyword: this.input, // 员工姓名/证件号码
        status: STATUS, // 筛选状态
        MaxResultCount: this.size, // 每页条数
        SkipCount: this.SkipCount, // 跳过条数
        EntryDateStart: regDateRange[0],
        EntryDateEnd: regDateRange[1]
      })
        .then(res => {
          this.total = res.data.totalCount
          this.tableData = res.data.items
          
          // 从msg字段中提取在职和离职数量
          if (res.msg) {
            const msgParts = res.msg.split(',');
            msgParts.forEach(part => {
              const [key, value] = part.split(':');
              if (key === 'Hired') {
                this.onTheJob = parseInt(value) || 0;
              } else if (key === 'Fired') {
                this.quitTheJob = parseInt(value) || 0;
              }
            });
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 点击查询按钮
    query () {
      this.page = 1
      this.getData()
      // this.getStatus()
    },
    // 重置
    reset () {
      // this.selectedValue = ''
      this.input = ''
      this.RegDateRange = []
      this.status = {
        0: true,
        1: true
      }
      this.getData()
    },
    // 点击筛选标签，刷新dataName对象 dataName: String，对象名; key: Number/String
    change (dataName, key) {
      let ischanged = Filter.call(this, dataName, key)
      if (ischanged) {
        this.page = 1
        this.getData()
      }
    },
    // 每页条数选择
    handleSizeChange (v) {
      this.size = v
      this.getData()
    },
    // 页码选择
    handleCurrentChange (v) {
      this.page = v
      this.getData()
    },
    // 日期格式转换
    date (dateStr) {
      return dateConvert(dateStr)
    },

    // 开关组1限制，至少打开一个
    changeSwitchGroup1 () {
      let choosen = []
      let switchGroup1 = this.switchGroup1
      for (let key in switchGroup1) {
        if (switchGroup1[key]) choosen.push(key)
      }
      if (choosen.length === 1) {
        this.disabled = choosen[0]
      } else {
        this.disabled = ''
      }
    },
    // 显示对话框
    dialog() {
      let status = this.status
      // 当用工状态全选时，需要输入其他查询条件
      if (status[0] == true && status[1] == true && !this.input && !this.RegDateRange[0] && !this.RegDateRange[1]) {
        this.$message.warning('请至少输入一个查询条件或选择一个筛选条件');
        return;
      }
      this.mask = !this.mask;
    },
    
    // 导出excel
    exportExcel () {
      let status = this.status
      
      let Statu = ''
      if (status[0] == true && status[1] == true) {
        Statu = -1 // 都选，传空字符串
      } else if (status[0] == true && status[1] == false) {
        Statu = 1
      } else if (status[0] == false && status[1] == true) {
        Statu = 2
      }
      
      // 验证至少选择了必填字段
      const requiredFields = ['员工姓名', '所属企业', '证件号码', '用工状态'];
      const hasAllRequired = requiredFields.every(field => this.export_value.includes(field));
      if (!hasAllRequired) {
        this.$message.warning('请确保已选择所有必填字段：员工姓名、所属企业、证件号码、用工状态');
        return;
      }
      
      // 获取当前日期
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const dateStr = `${year}${month}${day}`;
      
      // 获取客户全称
      const customerName = localStorage.getItem('tenant_name') || localStorage.getItem('companyName') || '客户';
      
      // 设置导出加载状态
      this.exportLoading = true;
      
      Download(
        'api/v1/employees/excel',
        {
          Keyword: this.input, // 员工姓名/证件号码
          Status: Statu, // 用工状态
          EntryDateStart: this.RegDateRange[0],
          EntryDateEnd: this.RegDateRange[1],
          ExportFields: this.export_value // 导出字段，直接传递数组
        },
        `${customerName}-员工信息-${dateStr}.xlsx`
      )
      .then(() => {
        // 导出成功
        this.exportLoading = false;
      })
      .catch(err => {
        // 导出失败
        this.exportLoading = false;
        this.$message.error('导出失败，请稍后重试');
        console.error('导出失败:', err);
      });
      
      this.mask = false;
    },
    // 处理行点击（支持双击取消跳转、拖动选中不跳转）
    handleRowClick (item) {
      // 如果正在拖动或已经双击，则不跳转
      if (this.isDragging || this.isDoubleClick) {
        // 重置双击状态
        this.isDoubleClick = false;
        return;
      }
      
      // 清除之前的定时器
      if (this.clickTimer) {
        clearTimeout(this.clickTimer);
      }
      
      // 设置单击定时器（300ms内无第二次点击则跳转）
      this.clickTimer = setTimeout(() => {
        this.$router.push({
          name: 'EmployeeInfoItem',
          params: { id: item.employeeId }
        });
        this.clickTimer = null;
      }, 300);
    },
    // 处理双击
    handleRowDblclick (item) {
      // 清除单击定时器
      if (this.clickTimer) {
        clearTimeout(this.clickTimer);
        this.clickTimer = null;
      }
      
      // 设置双击标志
      this.isDoubleClick = true;
      
      // 复制整行数据文本
      this.copyRowData(item);
    },
    // 处理鼠标按下
    handleRowMousedown () {
      this.isDragging = false;
    },
    // 处理鼠标移动
    handleRowMousemove () {
      this.isDragging = true;
    },
    // 处理鼠标释放
    handleRowMouseup () {
      // 拖动结束后延迟重置，确保拖动选中文字完成
      setTimeout(() => {
        this.isDragging = false;
      }, 100);
    },
    // 复制行数据文本
    copyRowData (item) {
      const rowText = `所属企业: ${item.customerName || ''}\n员工姓名: ${item.realName || ''}\n证件号码: ${item.idCard || ''}\n手机号码: ${item.mobilePhone || ''}\n用工状态: ${item.status === 0 ? '未入职' : item.status === 1 ? '在职' : '离职'}\n入职日期: ${this.date(item.entryDate)}`;
      
      // 使用 Clipboard API 复制
      navigator.clipboard.writeText(rowText).then(() => {
        this.$message.success('已复制整行数据');
      }).catch(() => {
        // 降级方案：创建临时textarea
        const textarea = document.createElement('textarea');
        textarea.value = rowText;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.$message.success('已复制整行数据');
      });
    },
    // 查看（保留原方法，用于操作列的查看按钮）
    view (item) {
      this.$router.push({
        name: 'EmployeeInfoItem',
        params: { id: item.employeeId }
      })
    },
    // 穿梭框渲染
    renderFunc (h, option) {
      return <span>{option.label}</span>
    },
    translateWidth (num) {
      return translateWidth(num)
    },
    // 绑定窗口缩放事件
    ifResize () {
      window.addEventListener('resize', this.resize)
    },
    resize () {
      this.tableWidth = JSON.parse(JSON.stringify(this.tableWidth))
    }
  },
  created () {},
  mounted () {
    this.getOptions()
    this.getData()
    // this.getStatus()
  },
  activated () {
    this.ifResize()
  },
  deactivated () {
    // 解除事件
    window.removeEventListener('resize', this.resize)
  },
  beforeDestroy () {}
}
</script>

<style lang="scss" scoped>
// 布局样式
.wrapper {
  padding: 150px 32px 24px 32px;
  > div {
    margin-bottom: 32px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .tags {
    padding: 0 48px 32px 0;
    .tag-group {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .options {
      flex: 1;
      div {
        width: 100%;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
  .sum-group {
    display: flex;
    padding: 24px 48px 24px;
    align-items: center;
    .sum {
      width: 240px;
      &:last-of-type {
        flex: 1;
      }
    }
  }
  .result {
    margin-top: 20px;
    padding: 48px;
  }
  .filter {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 22px 48px;
    position: fixed;
    top: 70px;
    left: 11.6vw;
    right: 32px;
    z-index: 100;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    .filter-row {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-wrap: wrap;

      .custom-es {
        min-width: 200px;
        width: 300px;
        @media (max-width: 1199px) {
          min-width: 100%;
          width: 100%;
        }
      }

      .date-group {
        display: flex;
        align-items: center;
        gap: 8px;
        flex: 1;
        min-width: 100%;
        @media (min-width: 1200px) {
          flex: none;
          min-width: auto;
        }
      }

      .date-label {
        font-size: 14px;
        color: #000;
        white-space: nowrap;
      }

      .status-group {
        display: flex;
        align-items: center;
        gap: 8px;
        flex: 1;
        min-width: 100%;
        @media (min-width: 1200px) {
          flex: none;
          min-width: auto;
        }

        .font_14_black {
          margin: 0;
        }
        
        .status-count {
          font-size: 14px;
          color: #f26828;
          font-weight: bold;
        }
      }

      .button-group {
        display: flex;
        gap: 12px;
        flex: 1;
        justify-content: flex-end;
        @media (max-width: 1199px) {
          min-width: 100%;
          margin-left: 0;
          justify-content: flex-start;
        }
        @media (min-width: 1200px) {
          flex: none;
          margin-left: auto;
          justify-content: flex-end;
        }
      }
    }
  }
}
// 查看按钮
.view {
  margin-right: 18px;
}

.transfer {
  display: flex;
  justify-content: center;
}
::v-deep
  .el-transfer-panel
  .el-transfer-panel__header
  .el-checkbox
  .el-checkbox__label {
  font-size: 14px;
  color: #000;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #5c74f5;
}
::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #5c74f5;
}
::v-deep .el-transfer__button {
  background-color: #5c74f5;
}

.wrapper {
  .export-title {
    margin-bottom: 32px;
  }
  .export-item {
    margin-bottom: 20px;
  }
}

// .switch {
//   flex-direction: column;
//   .switch-group {
//     flex: 1;
//     flex-direction: row;
//     align-items: center;
//     // justify-content: space-between;
//     padding-left: 10px;
//     margin-right: 0;
//     margin-bottom: 20px;
//     .switch-title {
//       white-space: nowrap;
//       margin-bottom: 0;
//       font-weight: bold;
//       color: #000;
//     }
//     .switch-item {
//       margin-left: 30px;
//       margin-bottom: 0;
//       min-width: 108px;
//     }
//   }
// }
.switch {
  flex-direction: column;
  padding: 0;
  .switch-group {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    // padding-left: 10px;
    margin-right: 0;
    margin-bottom: 20px;
    .switch-center {
      display: flex;
      flex-direction: row;
      align-items: center;
      min-width: 335px;
    }
    .switch-title {
      white-space: nowrap;
      margin-bottom: 0;
      font-weight: bold;
      color: #000;
    }
    .switch-item {
      margin-left: 30px;
      margin-bottom: 0;
      // min-width: 108px;
    }
  }
}
</style>
